<template>
  <div id="mainView" class="flow__body row container" data-test-component="document-page">
    <div class="small-12 medium-12 columns">
      <div class="row columns">
        <h1
          v-html="model.DocumentPageSettingsModel.DocumentSettingsModel.CommonSettingsModel.Title"
        />
      </div>

      <!-- START: document-list -->
      <div class="row push-down">
        <div class="small-12 medium-offset-6 medium-6 columns">
          <div class="search-input-container row">
            <div class="small-10 columns">
              <input
                v-model="search"
                type="search"
                :placeholder="
                  model.DocumentPageSettingsModel.DocumentSettingsModel.CommonSettingsModel
                    .SearchPlaceholder
                "
              />
            </div>
            <div class="small-2 columns text-right">
              <button type="submit" class="button white">
                <i class="icon-search" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row push-up push-down radio-inline align-middle">
        <div
          v-for="(filter, index) in model.DocumentPageSettingsModel.DocumentSettingsModel.Filters"
          :key="index"
          class="small-12 medium-6 large-2 columns"
        >
          <input
            :id="filter.FilterId"
            v-model="docType"
            type="radio"
            name="documents"
            :value="filter.FilterId"
          />
          <label :for="filter.FilterId" v-html="filter.FilterTitle" />
        </div>
      </div>

      <div class="row link-items columns">
        <article class="link-item__header show-for-medium">
          <h5 class="hide">
            Document List
          </h5>
          <div class="link-item row align-middle">
            <div
              class="link-date columns medium-2"
              v-html="
                model.DocumentPageSettingsModel.DocumentSettingsModel.CommonSettingsModel.ListDate
              "
            />
            <div
              class="link-title columns medium-4"
              v-html="
                model.DocumentPageSettingsModel.DocumentSettingsModel.CommonSettingsModel
                  .ListSubject
              "
            />
            <div
              class="link-type columns medium-3"
              v-html="
                model.DocumentPageSettingsModel.DocumentSettingsModel.CommonSettingsModel
                  .ListProduct
              "
            />
            <div
              class="link-reference columns medium-3"
              v-html="
                model.DocumentPageSettingsModel.DocumentSettingsModel.CommonSettingsModel
                  .ListReferenceNumber
              "
            />
          </div>
        </article>

        <transition-group name="list" tag="article" appear mode="out-in">
          <div
            v-for="(document, index) in currentDocuments"
            :key="index"
            class="link-item row align-middle"
          >
            <template v-if="index < size">
              <div class="link-date columns small-12 medium-2" v-html="document.Date" />
              <div class="link-title columns small-12 medium-4">
                <strong>
                  <a
                    :href="document.Link"
                    target="_blank"
                    @click="shouldShowClauseErrorModal($event, document)"
                    v-html="document.Title"
                  />
                </strong>
              </div>
              <div class="link-type columns small-12 medium-3" v-html="document.ProductName" />
              <div class="link-reference columns small-12 medium-3">
                <div
                  v-for="(reference, index) in document.References.filter((reference) => reference.ReferenceNumber !== null)"
                  :key="index"
                  v-html="reference.ReferenceName + ' ' + reference.ReferenceNumber"
                />
              </div>
            </template>
          </div>
        </transition-group>

        <!-- TODO: RADR - Tempoary Modal due to Clause error. Will be removed after fix. ref: PFK-2784 -->
        <transition
          v-cloak
          name="modal"
        >
          <v-modal
            :is-open="showClauseErrorModal"
            modal-class="alt-modal"
            @close="setShowClauseErrorModal(false)"
          >
            <template #content>
              <div class="row align-center text-center">
                <p
                  class="clause-error-modal-text"
                  v-html="clauseErrorDocument?.ClauseErrorModalText"
                />
              </div>
            </template>
            
            <template #buttons>
              <div class="row align-center">
                <a
                  class="button small-11 text-center"
                  :href="clauseErrorDocument?.Link"
                  target="_blank"
                  @click="setShowClauseErrorModal(false)"
                  v-html="clauseErrorDocument?.ClauseErrorModalButtonText"
                />
              </div>
            </template>
          </v-modal>
        </transition>
        <!--  -->
      </div>
      <!-- END: document-list -->

      <div
        class="link-items__footer"
        v-html="'Viser ' + currentDocuments.length + ' ud af ' + documents.length + ' dokumenter'"
      />

      <div v-if="documents.length > numberOfRows" class="row push-up">
        <div class="medium-6 medium-offset-3">
          <div class="row">
            <div class="medium-6 columns">
              <a v-if="previousDisabled" class="round-arrow-with-text disabled">
                <span class="round-arrow left" />
                <span
                  v-html="
                    model.DocumentPageSettingsModel.Previous +
                    ' ' +
                    model.DocumentPageSettingsModel.DocumentSettingsModel.CommonSettingsModel
                      .PageSize
                  "
                />
              </a>
              <a v-if="!previousDisabled" class="round-arrow-with-text" @click="showPrevious">
                <span class="round-arrow left" />
                <span
                  v-html="
                    model.DocumentPageSettingsModel.Previous +
                    ' ' +
                    model.DocumentPageSettingsModel.DocumentSettingsModel.CommonSettingsModel
                      .PageSize
                  "
                />
              </a>
            </div>
            <div class="medium-6 columns">
              <a v-if="nextDisabled" class="round-arrow-with-text disabled">
                <span
                  v-html="
                    model.DocumentPageSettingsModel.Next +
                    ' ' +
                    model.DocumentPageSettingsModel.DocumentSettingsModel.CommonSettingsModel
                      .PageSize
                  "
                />
                <span class="round-arrow right" />
              </a>
              <a v-if="!nextDisabled" class="round-arrow-with-text" @click="showNext">
                <span
                  v-html="
                    model.DocumentPageSettingsModel.Next +
                    ' ' +
                    model.DocumentPageSettingsModel.DocumentSettingsModel.CommonSettingsModel
                      .PageSize
                  "
                />
                <span class="round-arrow right" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// DocumentMetaDataIds are now skadesnr = 407, policynr = 285, others = 0, All documents = -1
export default {
  name: 'DocumentPage',
  props: {
    model: {
      type: Object,
      default() {
        return null;
      }
    },
    viewModel: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      documents: '',
      currentIndex: 0,
      size: '',
      search: '',
      docType: '-1',
      // TODO: RADR - Tempoary Modal due to Clause error. Will be removed after fix. ref: PFK-2784
      showClauseErrorModal: false,
      clauseErrorDocument: null
      //
    };
  },
  computed: {
    currentDocuments() {
      return this.documents.slice(this.currentIndex, this.currentIndex + this.size);
    },
    numberOfRows() {
      const docLength = this.currentDocuments.length;
      return this.size > docLength ? docLength : this.size;
    },
    nextDisabled() {
      return this.currentIndex + 1 + parseInt(this.numberOfRows) > this.documents.length;
    },
    previousDisabled() {
      return this.currentIndex === 0;
    }
  },
  watch: {
    currentIndex() {
      window.Utility.scrollToElem($('body'));
    },
    docType(val) {
      this.currentIndex = 0;
      const scope = this.searchResult || this.data;

      if (val === '-1') {
        this.documents = scope;
      } else {
        this.documents = scope.filter((document) => {
          const index = document.References.filter((reference) => reference.FilterId === val);
          if (index.length > 0) {
            return document;
          }
        });
      }
    },
    search() {
      if (this.search.length > 2) {
        this.currentIndex = 0;
        this.documents = this.data.filter((document) => {
          if (this.checkTitle(document) || this.checkReferenceNumber(document)) {
            return document;
          }
        });
        this.searchResult = this.documents;
      } else {
        this.searchResult = null;

        if (this.docType !== '-1') {
          this.docType = '-1';
        } else {
          this.documents = this.data;
        }
      }
    }
  },
  created() {
    this.documents = this.viewModel.Documents;
    this.size = parseInt(this.viewModel.PageSize);
  },
  mounted() {
    this.data = this.viewModel.Documents;
    this.docType =
      this.model.InitialDocumentType !== null &&
      typeof this.model.InitialDocumentType !== 'undefined'
        ? this.model.InitialDocumentType
        : '-1';
  },
  methods: {
    checkTitle(doc) {
      return doc.Title.toLowerCase().search(this.search) > -1 ? true : false;
    },
    checkReferenceNumber(doc) {
      const index = doc.References.filter((reference) => {
        if (reference.ReferenceNumber === null) {
          return;
        }
        return reference.ReferenceNumber.indexOf(this.search) > -1;
      });
      return index.length > 0 ? true : false;
    },
    showNext() {
      this.currentIndex = parseInt(this.currentIndex) + parseInt(this.size);
    },
    showPrevious() {
      this.currentIndex = parseInt(this.currentIndex) - parseInt(this.size);
    },
    // TODO: RADR - Tempoary Modal due to Clause error. Will be removed after fix. ref: PFK-2784
    shouldShowClauseErrorModal(event, document) {
      if (document.ShouldShowClauseErrorModal
        && document.ClauseErrorModalText != ''
        && document.ClauseErrorModalButtonText != '')
      {
        event.preventDefault();
        this.clauseErrorDocument = document;
        this.setShowClauseErrorModal(true);
      }
    },
    setShowClauseErrorModal(value) {
    this.showClauseErrorModal = value;
    },
    //
  }
};
</script>

<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';
@import 'src/styles/colors.scss';

.clause-error-modal-text {
  margin-top: rem-calc(20);
  margin-right: rem-calc(20);
  margin-left: rem-calc(20);
}
</style>